import React from "react";
import { useDropzoneContext } from "../Dropzone";
import { Button } from "../../../atoms";
import { DropzoneTriggerProps } from "../Dropzone.types";

const DropzoneTrigger = (props: DropzoneTriggerProps) => {
  const { selectFiles } = useDropzoneContext();
  return <Button {...props} onClick={selectFiles} />;
};

export default DropzoneTrigger;
